import { useCallback, useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./VideoIntro.module.css";
import NavPanel from "../components/NavPanel";

import ProgressBar from "../components/ProgressBar";
import NBLogoWhite from "../components/NBLogoWhite";

const VideoIntro = () => {
  const navigate = useNavigate();
  const [muted, setMuted] = useState(true);
  const [showLogo, setShowLogo] = useState(false);
  const videoRef = useRef(null);

  const onFrameContainerClick = useCallback(() => {
    if (videoRef.current.paused) {
      videoRef.current.play()
    } else {
      navigate("/who-best");
    }
  }, [navigate]);

  const handleMuteToggle = () => {
    setMuted((prev) => {
      const newMuted = !prev;
      if (videoRef.current) {
        videoRef.current.muted = newMuted;
      }
      return newMuted;
    });
  };

  // Track video time to show/hide logo
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleTimeUpdate = () => {
      const currentTime = video.currentTime;
      if (currentTime >= 3 && !showLogo) {
        setShowLogo(true);
      } else if (currentTime < 3 && showLogo) {
        setShowLogo(false);
      }
    };

    video.addEventListener('timeupdate', handleTimeUpdate);
    return () => {
      video.removeEventListener('timeupdate', handleTimeUpdate);
    };
  }, [showLogo]);

  return (
    <div className={styles.introVideo}>
      <NavPanel postion='full' onClick={onFrameContainerClick} />

      <div className={styles.player}>
        <video
          ref={videoRef}
          muted={muted}
          autoPlay
          playsInline
          loop
          src={'introvideo.mp4'}
          style={{
          height: '100%',
          width: '100%',
          objectFit: 'cover'
        }}
       />
      </div>

      <button
        className={styles.muteButton}
        onClick={handleMuteToggle}
        aria-label={muted ? "Unmute video" : "Mute video"}
      >
        {muted ? (
          // Mute icon (simple SVG)
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line></svg>
        ) : (
          // Unmute icon (simple SVG)
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19 12c0-1.77-.77-3.29-2-4.29M19 12c0 1.77-.77 3.29-2 4.29M15 8.71V15.3"></path></svg>
        )}
      </button>

      <ProgressBar current='0' />
      <NBLogoWhite showLogo={showLogo}/>
    </div>
  );
};

export default VideoIntro;
